<mat-dialog-content>
  <div class="row justify-content-md-center">
    <div class="row justify-content-md-center">
      <div class="col col-md-3">
        <a (click)="exportExcel(quotationList)"
          ><button mat-raised-button class="Warn">
            {{ 'Export' | translate }}
          </button></a
        >
      </div>
      <div class="col col-md-4">
        <a (click)="filter(quotationList)"
          ><button mat-raised-button class="Warn">
            {{ 'Preview' | translate }}
          </button></a
        >
      </div>
      <div class="col col-md-3">
        <a (click)="closeDialog()"
          ><button mat-raised-button class="Warn">
            {{ 'Close' | translate }}
          </button></a
        >
      </div>
    </div>
  </div>

  <div class="row justify-content-md-center">
    <div class="col-md-auto">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Enter a date range' | translate }}</mat-label>
        <mat-date-range-input
          [formGroup]="range"
          [rangePicker]="picker"
          matTooltip="Info about the action"
          matTooltipClass="example-tooltip-red"
        >
          <input
            matStartDate
            formControlName="start"
            placeholder="Start date"
          />
          <input matEndDate formControlName="end" placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        @if (range.controls.start.hasError('matStartDateInvalid')) {
          <mat-error>{{ 'Invalid start date' | translate }}</mat-error>
        }
        @if (range.controls.end.hasError('matEndDateInvalid')) {
          <mat-error>{{ 'Invalid end date' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-md-auto">
      <mat-form-field>
        <mat-label>{{ 'Filter by seller' | translate }}</mat-label>
        <ng-container>
          <input
            id="input-top"
            type="text"
            matInput
            [matAutocomplete]="autoSeller"
            [formControl]="sellerForm"
          />
        </ng-container>
        <mat-autocomplete
          #autoSeller="matAutocomplete"
          [displayWith]="displayFnSeller"
        >
          @for (seller of filteredOptionsSeller | async; track seller) {
            <mat-option [value]="seller">
              {{ seller.nombre }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-md-auto">
      <a (click)="clean()"
        ><button mat-raised-button class="Warn">
          {{ 'Clean' | translate }}
        </button></a
      >
    </div>
  </div>

  @if (arrayExcel.length > 0) {
    <div>
      <table id="season-tble" class="table table-striped">
        <tr>
          <td>{{ companyName }}</td>
        </tr>
        <tr>
          <td>
            {{ '-------------------------------------------------------' }}
          </td>
        </tr>
        <tr>
          <td>{{ 'REQUIREMENTS FINISHED PRODUCTS' | translate }}</td>
        </tr>
        <tr>
          <th>{{ 'Code' | translate }}</th>
          <th>{{ 'Description' | translate }}</th>
          @for (item of arrayCustomers; track item) {
            <th>{{ item }}</th>
          }
          <th>{{ 'Total UDS' | translate }}</th>
          <th>{{ 'Liters' | translate }}</th>
        </tr>
        @for (item of arrayExcel; track item) {
          <tr>
            <td>{{ item.code }}</td>
            <td>{{ item.description }}</td>
            @for (values of item.values; track values) {
              <td>{{ values }}</td>
            }
            <td>{{ item.total }}</td>
            <td id="liters">{{ item.total * item.presentation | fixed }}</td>
          </tr>
        }
        <tr>
          <td></td>
          <td>{{ 'TOTAL' }}</td>
          @for (item of arrayTotals; track item) {
            <td>{{ item }}</td>
          }
          <td>{{ total }}</td>
          <td>{{ calcAllLiters() }}</td>
        </tr>
      </table>
    </div>
  }
</mat-dialog-content>
